import { render } from "./sanhengtufuwenben.vue?vue&type=template&id=275d6f2f&scoped=true"
import script from "./sanhengtufuwenben.vue?vue&type=script&lang=js"
export * from "./sanhengtufuwenben.vue?vue&type=script&lang=js"

import "./sanhengtufuwenben.vue?vue&type=style&index=0&id=275d6f2f&scoped=true&lang=css"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275d6f2f"]])

export default __exports__